import apiController from '@/utils/apiController';

// Telas × tipos de acesso do usuário logado (novo modelo de permissões).
// Fica só em memória: recarrega no login e ao abrir o app com sessão ativa.
// Serve para esconder menu e botões; quem decide o acesso é sempre a API.

const state = () => ({
  carregado: false,
  isSuperadmin: false,
  // { VEICULOS: { nome: 'Veiculos', rota_front: '/veiculos', tipos: ['READ', 'UPDATE'] } }
  telas: {},
});

function indexarPorNome(telas) {
  const porNome = {};
  Object.keys(telas).forEach((cod) => {
    porNome[telas[cod].nome] = telas[cod];
  });
  return porNome;
}

const getters = {
  // can('VEICULOS', 'DELETE') ou can('Veiculos', 'DELETE'): aceita o código da tela
  // ou o nome usado em meta.permissionScreen. Tipo padrão: READ.
  can: (state, getters) => (tela, tipo = 'READ') => {
    if (state.isSuperadmin) return true;
    const encontrada = state.telas[tela] || getters.telasPorNome[tela];
    return !!(encontrada && encontrada.tipos.includes(tipo));
  },
  telasPorNome: (state) => indexarPorNome(state.telas),
};

const mutations = {
  setPermissoes(state, { is_superadmin, telas }) {
    state.isSuperadmin = Number(is_superadmin) === 1;
    state.telas = telas || {};
    state.carregado = true;
  },
  limpar(state) {
    state.isSuperadmin = false;
    state.telas = {};
    state.carregado = false;
  },
};

const actions = {
  carregar({ commit }) {
    return apiController
      .request(apiController.endpoints.getMinhaspermissoes, { silent: true })
      .then((response) => {
        commit('setPermissoes', response.data);
        return response.data;
      })
      .catch(() => {
        commit('limpar');
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
